import { HttpRequest, HttpMethod, axiosInstance } from "./http";

// Referral codes — BO CRUD on the App PG (Phase 2 spec 2026-10-13 §3.1).
// Envelope: {data: …} (+ total on the list). Errors carry a stable `code`:
// schema_missing (503), invalid_body (+ errors[{field, rule}]), code_taken,
// template_invalid, invalid_landing, too_many, stale, not_found, not_retryable.
// Action routes are POST /:id/<verb>. Role: marketing (read / write).
const BASE = "/api/v1/bo/referral-codes";

class ReferralCodeProvider extends HttpRequest {
    // ?q=&state=all|active|scheduled|expired|full|disabled&owner_bo_user_id=&team=&campaign=&batch_id=&page=1&limit=20
    list(params) {
        return this.request(HttpMethod.Get, BASE, params);
    }

    // CSV (UTF-8 BOM), same filters, ≤ 5000 rows. Binary: axios directly.
    exportCsv(params) {
        return axiosInstance.get(`${BASE}/export.csv`, { params, responseType: "blob" });
    }

    // {data:{teams:[string], campaigns:[string]}}
    meta() {
        return this.request(HttpMethod.Get, `${BASE}/meta`);
    }

    // {data:[{id, name, nick_name}]}
    owners(q) {
        return this.request(HttpMethod.Get, `${BASE}/owners`, q ? { q } : {});
    }

    // {data:[{id, code, name_th, name_en, discount_type, discount_value, max_discount, min_purchase, expiry_days, valid_to, quota_left, eligibility}]}
    couponTemplates() {
        return this.request(HttpMethod.Get, `${BASE}/coupon-templates`);
    }

    // {data:{normalized, available, reason: ""|"format"|"taken"}}
    checkCode(code) {
        return this.request(HttpMethod.Get, `${BASE}/check-code`, { code });
    }

    // CodeInput + code (blank = generate with prefix)
    create(payload) {
        return this.request(HttpMethod.Post, BASE, payload);
    }

    // {mode, owner_bo_user_ids | count, prefix, ...CodeInput} → {data:{batch_id, codes}}
    bulk(payload) {
        return this.request(HttpMethod.Post, `${BASE}/bulk`, payload);
    }

    get(id) {
        return this.request(HttpMethod.Get, `${BASE}/${id}`);
    }

    // CodeInput + expected_updated_at
    update(id, payload) {
        return this.request(HttpMethod.Put, `${BASE}/${id}`, payload);
    }

    disable(id) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/disable`, {});
    }

    enable(id) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/enable`, {});
    }

    // image/png; download=1 adds Content-Disposition attachment.
    qrBlob(id, { size = 512, download = false } = {}) {
        const params = { size };
        if (download) params.download = 1;
        return axiosInstance.get(`${BASE}/${id}/qr.png`, { params, responseType: "blob" });
    }

    // {data: MemberRow} | 409 not_retryable
    retryGrant(redemptionId) {
        return this.request(HttpMethod.Post, `${BASE}/redemptions/${redemptionId}/retry-grant`, {});
    }
}

export default ReferralCodeProvider;
